import { EMobileActiveSideTypes } from './types';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить активную сторону мобильного приложения
 */
export const setMobileActiveSide = actionGenerator<EMobileActiveSideTypes.SetActive, EMobileLayoutActiveSide>(
  EMobileActiveSideTypes.SetActive,
);
